import { UserType } from '@/hooks/useUserTypesQuery';
import { FacilityFacilityTypeEnum } from '@/types/crm-screener';

interface UserFacilityAccess {
  id: string;
  facility_id: string;
  user_id: string;
  granted_by_user_id: string;
  facility: {
    id: string;
    name: string;
    address: string;
  };
}

export enum UserStatus {
  ACTIVE = 'active',
  PENDING = 'pending',
  DEACTIVATED = 'deactivated'
}

export class UserPayload {
  id: string;
  first_name: string;
  status: UserStatus;
  last_name: string;
  state_id?: string;
  title?: string;
  s3_photo_key: string;
  s3_photo_url?: string;
  date_of_hire: string;
  dob: string;
  ssn: string;
  email: string;
  gender?: string | null;
  phone: string;
  user_type_id: string;
  user_type?: UserType | null;
  is_deleted: boolean;
  facility_id: string;
  timezone_id: string;
  last_sign_in_time: string;
  temp_password: string;
  receive_crm_notifications: boolean | null;
  organization_employment_type_id: string;
  address: string;
  emergency_contact_name: string;
  emergency_contact_number: string;
  deletedAt?: string | null;
  organization_settings?: {
    // Only available when calling /users/users/current
    billing_enabled: boolean;
    is_screener_customer: boolean;
  };
  organization_details?: {
    id: string;
    name: string;
  };
  username: string | null;
  enabled_dynamic_permissions?: string[] | null;
  login_url_preference?: string;
  user_facility_accesses?: UserFacilityAccess[];
  app_metadata?: {
    mfa_enrolled?: boolean;
    mfa_required?: boolean;
    mfa_allowed_methods?: string[];
  };
  email_hash?: string;
  auth_method?: 'password' | 'sso';
  hospital_chat_signature?: string | null;
  default_screener_facility_id?: string | null;
  default_screener_facility_type?: FacilityFacilityTypeEnum | null;

  constructor(payload: UserPayload) {
    const safePayload = { ...payload } as UserPayload & {
      auth0_id?: unknown;
    };
    delete safePayload.auth0_id;
    Object.assign(this, safePayload);
  }

  get fullName(): string {
    return `${this.first_name} ${this.last_name}`;
  }

  get initials(): string {
    return `${this.first_name[0]}${this.last_name[0]}`;
  }
}
